<template>
  <header class="slider">
    <div class="main-slider" v-if="banners">
      <swiper :loop="true" :speed="500" :parallax="true" :grabCursor="true" :watchSlidesProgress="true"
        :centeredSlides="true" :autoplay="{
          delay: 5000,
          disableOnInteraction: false,
        }" :pagination=paginat :modules="modules">

        <swiper-slide v-for="item in banners" :key="item.ban_name">
          <div class="slide-inner" :style="{ 'background-image': 'url(' + uploadPath + item.ban_name + ')' }">
            <div class="container" data-swiper-parallax="200">
              <!--  <h6 class="tagline" v-if="item.ban_tag">{{ item.ban_tag }}</h6> -->
              <h2 class="name" v-if="item.ban_text">
                {{ item.ban_text }} <br>
                <strong v-if="item.ban_tag">  {{ item.ban_tag }}</strong>
              </h2>
              <ul class="features">
                <!-- <li> -->
                  <!-- <div class="rate">
                    <svg class="circle-chart" viewBox="0 0 30 30" width="40" height="40"
                      xmlns="http://www.w3.org/2000/svg">
                      <circle class="circle-chart__background" stroke="#2f3439" stroke-width="2" fill="none" cx="15"
                        cy="15" r="14"></circle>
                      <circle class="circle-chart__circle" stroke="#4eb04b" stroke-width="2" stroke-dasharray="50,100"
                        cx="15" cy="15" r="14"></circle>
                    </svg>
                    <b>5.4</b> Ratings
                  </div> -->
                  <!-- end rate -->
                <!-- </li> -->
                <li>
                  <div class="year">{{ item.ban_diamen }}</div>
                </li>
                <!-- <li>
                  <div class="hd">4K <b>ULTRA HD</b></div>
                </li> -->
                <li>
                  <div class="tags" v-if="item.ban_lang">{{ item.ban_lang }}</div>
                </li>
              </ul>
              <p class="description" v-if="item.ban_desc">{{ item.ban_desc }}
              </p>
              <!-- <a href="movies-details.html" class="play-btn">Book Tickets</a>  -->
              <a :href=item.ban_link data-vbtype="video" class="add-btn venobox"
                v-if="item.ban_link"><i class="lni lni-play"></i></a>
            </div>
            <!-- end container -->
          </div>
        </swiper-slide>

        <!-- <swiper-slide><div>
          f
        </div></swiper-slide> -->

      </swiper>
      <div class="swiper-pagination"></div>
    </div>
  </header>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import venobox from "venobox";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation, } from 'swiper';
import axios from 'axios';
import { URL, UPLOADS } from '@/conf.js';

export default {
  data() {
    return {
      myswiper: null,
      uploadPath: UPLOADS,
      imgPath: process.env.BASE_URL,
      result: null,
      banners: null,
      modules: [Autoplay, Pagination, Navigation],
      loaded: false,
      paginat: {
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><circle r="13" cy="15" cx="15"></circle></svg></span>';
        },
      },


    };
  },
  components: {
    SwiperSlide,
    Swiper
  },
  methods: {
    async getBanners() {
      
      axios.get(URL + 'banners')
        .then(response => {
          this.loaded = true;
          this.result = response.data;
          const resultarr = this.result.response.result
          this.banners = resultarr;
        }).then(()=>{
          new venobox();

        })
    },
  },
  mounted() {
    this.getBanners();
  },


};
</script>
<style>
@import "../../../node_modules/venobox";
</style>
